<template>
  <div class="search-in-section">
    <div class="search-in-section__sections">
      <pCheckbox
        v-for="type in profileTypesList"
        :key="type"
        :modelValue="searchStore.searchOptions.profileTypes.includes(type)"
        :label="descriptionTypes[type]"
        @update:modelValue="searchStore.setType(type)"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import pCheckbox from '@/common/pCheckbox/pCheckbox.vue';
import { profileTypes } from "@/common/types/profileTypes";
import { computed, ComputedRef } from "vue";
import { useSearchStore } from "@/searchSection/store/searchStore";

const searchStore = useSearchStore()
const descriptionTypes: object = {
  1: 'Индивидуалки',
  2: 'Массажистки',
  3: 'БДСМ',
}

const profileTypesList: ComputedRef<profileTypes[]> = computed(() => {
  return Object.keys(profileTypes)
      .filter((type) => !isNaN(Number(type)))
      .map((type) => Number(type))
})
</script>

<style scoped lang="scss">
.search-in-section {
  margin-top: 16px;

  &__sections {
    display: flex;
    align-items: center;
    column-gap: 56px;
    row-gap: 8px;
    flex-wrap: wrap;
  }
}
</style>